class JobDetailsController {
  constructor($scope, $stateParams, DataService) {
    "ngInject";
    this.name = 'jobDetails';
    this.$scope = $scope;
    this.formsite = {anchorId: '2019440383'}
    let self = this;
    this.jobInfo = {};
    this.dataService = DataService;

    DataService.getJob($stateParams.jobId).then(function(response) {
        self.jobInfo = response.data;
        self.loadForm();
    });
  }

  loadForm() {
    let ctrl = this;
    this.$scope.$$postDigest(function(){
      EmbedManager.embed({
        key: "https://fs27.formsite.com/res/showFormEmbed?EParam=m%2FOmK8apOTDhIvZxp8pKvu98uLar7Lz1&2019440383",
        width: "100%",
        mobileResponsive: true,
        prePopulate: {'7':ctrl.jobInfo.key}
      });
    });
  }

  /**
  * util method for breaking out the text into and array for bullet points
  */
  filterSentences(paragraph){
    if(paragraph) {
        let filtered = paragraph.split(".");
        filtered.pop();
        return filtered;
    }

    return [];
  }
}

export default JobDetailsController;



// WEBPACK FOOTER //
// ./app/components/jobDetails/jobDetails.controller.js